module.exports = ($scope) ->
  $scope.isArray = angular.isArray
  $scope.isNumber = angular.isNumber

  $scope.isObject = (val) ->
    # In JavaScript, an array is also considered an 'object', so let's exclude it
    # as what we really want is to match key-value objects / dictionaries
    angular.isObject(val) and not angular.isArray(val)

  $scope.isPlainValue = (val) ->
    not angular.isObject(val)
